import { PhotoshopController } from "../photoshopController.js";
import { GlWidget } from "./glWidget.js";
import { GLEngine } from "../GL/engine.js";
import { MenuWidget } from "./menuWidget.js";
import { ToolsParemetersWidget } from "./toolsParametersWidget.js";
import { ToolsPanelWidget } from "./toolsPanelWidget.js";
import { DatasPanelWidget } from "./datasPanelWidget.js";
import { Shaders } from "../templates.js";
import { LuminosityContrastParameterWidget } from "./widget/filters/parameters/luminosityContrastParameterWidget.js";
import { LevelsParameterWidget } from "./widget/filters/parameters/levelsParameterWidget.js";
import { HueSaturationParameterWidget } from "./widget/filters/parameters/hueSaturationParameterWidget.js";
import { ColorBalanceParameterWidget } from "./widget/filters/parameters/colorBalanceParameterWidget.js";
import { SharpenParameterWidget } from "./widget/filters/parameters/sharpenParameterWidget.js";
import { Alpha2ColorParameterWidget } from "./widget/filters/parameters/alpha2ColorParameterWidget.js";
import { SelectiveCorrectionParameterWidget } from "./widget/filters/parameters/selectiveCorrectionParameterWidget.js";

export class PhotoshopWidget {
    parentElement: HTMLElement;
    onSaveCallback: any;
    photoshopController: PhotoshopController;
    glWidget: GlWidget;
    engine: GLEngine;
    menuWidget: any;
    toolsParemetersWidget: any;
    toolspanelWidget: any;
    dataPanelWidget: any;
    activeOperationWidget: any | null;
    // #region
    PSTool_setting_sizeHardnessOnCLick: any;
    PSTool_setting_size_inputOnChange: any;
    PSTool_hardness_inputOnChange: any;
    PSTool_setting_exposition_inputOnChange: any;
    PSTool_setting_rotation_input_buttonOnChange: any;
    PSTool_setting_rotation_input_sliderOnChange: any;
    PSPolygonal_selection_toolOnClick: any;
    PSRectangular_selection_toolOnClick: any;
    PSEyeDropper_selection_toolOnClick: any;
    PSBrush_selection_toolOnClick: any;
    PSEraser_selection_toolOnClick: any;
    PSDensity_plus_selection_toolOnClick: any;
    PSDensity_low_selection_toolOnClick: any;
    PSStamp_selection_toolOnClick: any;
    PSVertical_rotation_selection_toolOnClick: any;
    PSHorizontal_rotation_selection_toolOnClick: any;
    PSRotationZ_selection_toolOnClick: any;
    // #endregion

    constructor(parentElement: HTMLElement, onSaveCallback?: any) {
        this.parentElement = parentElement;
        this.onSaveCallback = onSaveCallback;

        this.parentElement.innerHTML = PhotoshopWidget.html();

        this.photoshopController = new PhotoshopController(this.initializeToolRangeCallback.bind(this), this);
        this.glWidget = new GlWidget(this.parentElement, this.photoshopController);
        this.engine = GLEngine.create(Shaders, this.glWidget.gl, this.activeOperationCallback.bind(this));
        this.photoshopController.PSEngine = this.engine;

        this.menuWidget = new MenuWidget(this.parentElement, this.photoshopController, this.onSaveCallback);
        this.toolsParemetersWidget = new ToolsParemetersWidget(this.parentElement, this.photoshopController);
        this.toolspanelWidget = new ToolsPanelWidget(this.parentElement, this.photoshopController, this.updateIfCallback.bind(this), this.updateModelCallback.bind(this));
        this.dataPanelWidget = new DatasPanelWidget(this.parentElement, this.photoshopController, this);
        this.activeOperationWidget = null;

        // menu event
        this.menuWidget.buildMenu();

        // toolsParemeters events
        this.PSTool_setting_sizeHardnessOnCLick = this.toolsParemetersWidget.tool_setting_sizeHardnessOnCLick.bind(this);
        this.PSTool_setting_size_inputOnChange = this.toolsParemetersWidget.tool_size_inputOnChange.bind(this);
        this.PSTool_hardness_inputOnChange = this.toolsParemetersWidget.tool_hardness_inputOnChange.bind(this);
        this.PSTool_setting_exposition_inputOnChange = this.toolsParemetersWidget.tool_setting_exposition_inputOnChange.bind(this);
        this.PSTool_setting_rotation_input_buttonOnChange = this.toolsParemetersWidget.tool_setting_rotation_input_buttonOnChange.bind(this);
        this.PSTool_setting_rotation_input_sliderOnChange = this.toolsParemetersWidget.tool_setting_rotation_input_sliderOnChange.bind(this);

        // toolsPanel events
        this.PSPolygonal_selection_toolOnClick = this.toolspanelWidget.polygonal_selection_toolOnClick.bind(this);
        this.PSRectangular_selection_toolOnClick = this.toolspanelWidget.rectangular_selection_toolOnClick.bind(this);
        this.PSEyeDropper_selection_toolOnClick = this.toolspanelWidget.eyeDropper_selection_toolOnClick.bind(this);
        this.PSBrush_selection_toolOnClick = this.toolspanelWidget.brush_selection_toolOnClick.bind(this);
        this.PSEraser_selection_toolOnClick = this.toolspanelWidget.eraser_selection_toolOnClick.bind(this);
        this.PSDensity_plus_selection_toolOnClick = this.toolspanelWidget.density_plus_selection_toolOnClick.bind(this);
        this.PSDensity_low_selection_toolOnClick = this.toolspanelWidget.density_low_selection_toolOnClick.bind(this);
        this.PSStamp_selection_toolOnClick = this.toolspanelWidget.stamp_selection_toolOnClick.bind(this);
        this.PSVertical_rotation_selection_toolOnClick = this.toolspanelWidget.vertical_rotation_selection_toolOnClick.bind(this);
        this.PSHorizontal_rotation_selection_toolOnClick = this.toolspanelWidget.horizontal_rotation_selection_toolOnClick.bind(this);
        this.PSRotationZ_selection_toolOnClick = this.toolspanelWidget.rotationZ_selection_toolOnClick.bind(this);

        this.resizeGl();
        this.resizeDataPanel();

        window.addEventListener('resize', this.handleResize);
        window.addEventListener('pointerup', this.handlePointerUp);
        window.addEventListener('keydown', this.handleKeydown);

        if (navigator.userAgent.toLowerCase().indexOf('electron') !== -1) {
            const remote = require('@electron/remote');
            var args = this.processArgs(remote.process.argv);
            if (args.file) {
                this.photoshopController.openFromURL(args.file, args.alpha, function () {
                    if (args.background) {
                        this.photoshopController.openFromURL(args.background, null, function () {
                            this.postProdAuto(args, remote);
                        }.bind(this), function () {
                            //error retrieving image --> close app
                            remote.process.exit(-2);
                        });
                    } else {
                        this.postProdAuto(args, remote);
                    }
                }.bind(this), function () {
                    //error retrieving image --> close app
                    remote.process.exit(-2);
                });
                console.log(remote.process.argv);
            }
        }

        this.photoshopController.update();
    }

    destroy() {
        window.removeEventListener('pointerup', this.handlePointerUp);
        window.removeEventListener('keydown', this.handleKeydown);
        window.removeEventListener('resize', this.handleResize);
        this.engine.destroy();
        this.menuWidget.destroy();
        this.dataPanelWidget.destroy();
        this.parentElement.replaceChildren();
    }

    handleResize = (event) => {
        this.resizeGl(event);
        this.resizeDataPanel(event);
    }

    handlePointerUp = (event) => {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        event.stopPropagation();
        this.photoshopController.stopRendering();
        if (this.photoshopController.PSCamera.started()) {
            this.photoshopController.PSCamera.end();
        }

        if (this.photoshopController.PSEngine.activeLayer && this.photoshopController.PSEngine.activeLayer.camera.started()) {
            this.photoshopController.PSEngine.activeLayer.camera.end();
        }

        if (event.button === 0 && this.photoshopController.PSEngine.selection.activated) {
            this.photoshopController.PSEngine.renderSelection();
        }

        if (event.button === 0 && this.photoshopController.PSEngine.activeOperation) {
            this.photoshopController.endOperation();
        }
    }

    brushSizeStep(size) {
        if (size < 10) {
            return 1;
        } else if (size < 50) {
            return 5;
        } else if (size < 100) {
            return 10;
        } else if (size < 200) {
            return 25;
        } else if (size < 300) {
            return 50;
        }

        return 100;
    }

    decraseBrushSize() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        if (!this.photoshopController.PSEngine.activeOperation) {
            return;
        }

        if (this.photoshopController.PSEngine.activeOperation.type !== 'TOOL') {
            return;
        }

        this.photoshopController.PSEngine.activeOperation.size -= this.brushSizeStep(this.photoshopController.PSEngine.activeOperation.size);
        this.photoshopController.update();
    }

    increaseBrushSize() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        if (!this.photoshopController.PSEngine.activeOperation) {
            return;
        }

        if (this.photoshopController.PSEngine.activeOperation.type !== 'TOOL') {
            return;
        }

        this.photoshopController.PSEngine.activeOperation.size += this.brushSizeStep(this.photoshopController.PSEngine.activeOperation.size);
        this.photoshopController.update();
    }

    handleKeydown = (event) => {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        switch (event.keyCode) {
            case 8:
                event.preventDefault();
                this.photoshopController.PSEngine.delete();
                this.photoshopController.update();
                break;
            case 90:
                event.preventDefault();
                if (event.ctrlKey && event.shiftKey) {
                    this.photoshopController.PSEngine.redo();
                    this.photoshopController.update();
                } else if (event.ctrlKey) {
                    this.photoshopController.PSEngine.undo();
                    this.photoshopController.update();
                }
                break;
            case 83:
                event.preventDefault();
                if (event.ctrlKey) {
                    if (this.onSaveCallback) {
                        var pixels = this.photoshopController.PSEngine.grabImage();
                        if (pixels) {
                            this.onSaveCallback(pixels);
                        }
                    }
                }
                break;
            case 27:
                event.preventDefault();
                this.photoshopController.PSEngine.selection.clear();
                break;
            case 191:
                event.preventDefault();
                this.decraseBrushSize();
                break;
            case 223:
                event.preventDefault();
                this.increaseBrushSize();
                break;
        }
    }

    processArgs(argv) {
        type Args = {
            format: string;
            file?: string;
            background?: string;
            alpha?: string;
            delivrable?: string;
            env?: string;
            preset?: string;
            output?: string;
        };
        const args: Args = {
            format: 'image/jpeg'
        };
        var i = 2;
        if (argv[0].indexOf("Photoshop.exe") > 0) {
            i = 1;
        }
        for (; i < argv.length; i += 2) {
            var arg = argv[i];
            if (arg === 'file') {
                args.file = argv[i + 1];
            }
            if (arg === 'background') {
                args.background = argv[i + 1];
            }
            if (arg === 'alpha') {
                args.alpha = argv[i + 1];
            }
            if (arg === 'delivery') {
                args.delivrable = argv[i + 1];
            }
            if (arg === 'env') {
                args.env = argv[i + 1];
            }
            if (arg === 'preset') {
                args.preset = argv[i + 1];
            }
            if (arg === 'format') {
                args.format = (argv[i + 1] === 'png' ? 'image/png' : 'image/jpeg');
            }
            if (arg === 'output') {
                args.output = argv[i + 1];
            }
        }
        return args;
    }

    postProdAuto(args, remote) {

        switch (args.preset) {
            case 'unreal_after':
                this.photoshopController.unreal_after();
                break;
            case 'unreal_night':
                this.photoshopController.unreal_night();
                break;
            case 'unreal_axo':
                this.photoshopController.unreal_axo();
                break;
            case 'packshot':
                this.photoshopController.packshot();
                break;
            case 'alpha-layer':
                break;
            default:
                return;
        }
        if (!this.photoshopController.PSEngine) {
            return;
        }

        this.photoshopController.update();
        const imageData = this.photoshopController.PSEngine.grabImage();
        if (!imageData) {
            return;
        }
        const canvas = document.createElement('canvas');
        canvas.width = imageData.width;
        canvas.height = imageData.height;
        const ctx = canvas.getContext('2d');
        if (ctx) {
            ctx.putImageData(imageData, 0, 0);
        }
        var exporter = canvas;
        if (args.format === 'image/jpeg') {
            exporter = canvas.cloneNode(true) as HTMLCanvasElement;
            var context = exporter.getContext('2d');
            if (context) {
                context.fillStyle = 'white';
                context.fillRect(0, 0, exporter.width, exporter.height);
                context.drawImage(canvas, 0, 0);
            }
        }
        exporter.toBlob(function (blob) {
            if (!blob) {
                return;
            }
            var filename = args.file.replace(/^.*[\\\/]/, '');
            if (args.format === 'image/jpeg') {
                filename = filename.substr(0, filename.lastIndexOf(".")) + ".jpg";
            } else {
                filename = filename.substr(0, filename.lastIndexOf(".")) + ".png";
            }
            // save to output file
            blob.arrayBuffer().then(function (data) {
                const fs = require('fs');
                fs.writeFileSync(args.output, new DataView(data));
                remote.process.exit(0);
            })

            canvas.remove();
        }, args.format, 0.94);
    }

    static html() {
        return `
            <div id="photoshop-container" style="height: calc(100%)">
            ` + MenuWidget.html() + `
            ` + ToolsParemetersWidget.html() + `
            ` + ToolsPanelWidget.html() + `
            ` + GlWidget.html() + `
            ` + DatasPanelWidget.html() + `                
            </div>
        `;
    }

    loadImage(url, alphaUrl, loaded?, error?) {
        this.photoshopController.openFromURL(url, alphaUrl, loaded, error);
    }

    updateIfCallback() {
        this.toolsParemetersWidget.updateIf();
    }

    updateModelCallback() {
        this.toolsParemetersWidget.updateModel();
    }

    initializeToolRangeCallback() {
        this.toolsParemetersWidget.initializeToolRange();
    }

    activeOperationCallback(operation) {
        if (this.activeOperationWidget) {
            this.activeOperationWidget.destroy();
            this.activeOperationWidget = null;
        }
        if (operation) {
            const parent = document.getElementById("reglages");
            if (!parent) {
                console.error('Parent element with id "reglages" not found.');
                return;
            }
            switch (operation.program) {
                case "luminosityContrast":
                    this.activeOperationWidget = new LuminosityContrastParameterWidget(parent, this.photoshopController, operation);
                    break;
                case "levels":
                    this.activeOperationWidget = new LevelsParameterWidget(parent, this.photoshopController, operation);
                    break;
                case "hueSaturation":
                    this.activeOperationWidget = new HueSaturationParameterWidget(parent, this.photoshopController, operation);
                    break;
                case "colorBalance":
                    this.activeOperationWidget = new ColorBalanceParameterWidget(parent, this.photoshopController, operation);
                    break;
                case "sharpen":
                    this.activeOperationWidget = new SharpenParameterWidget(parent, this.photoshopController, operation);
                    break;
                case "alpha2Color":
                    this.activeOperationWidget = new Alpha2ColorParameterWidget(parent, this.photoshopController, operation);
                    break;
                case "selectiveCorrection":
                    this.activeOperationWidget = new SelectiveCorrectionParameterWidget(parent, this.photoshopController, operation);
                    break;
                default:
                    break;
            }
        }
    }

    resizeGl(_event?) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.glWidget.resize();
        this.photoshopController.PSEngine.resize();
        this.photoshopController.update();
    }

    resizeDataPanel(_event?) {
        this.dataPanelWidget.resize();
    }
}